import PropTypes from 'prop-types';
import { useState } from 'react';
import classNames from 'classnames';
import Button from '@alltrails/shared/denali/components/Button';
import { useIntl } from '@alltrails/shared/react-intl';
import Phone from '../Phone';
import * as styles from './styles.module.scss';
import useLanguageRegionCode from '../../hooks/useLanguageRegionCode';

function ShareModalDrawerTextMessage({ sendSMSMessage, shareObject }) {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();
  const [showSpinner, setShowSpinner] = useState(false);
  const [buttonLabel, setButtonLabel] = useState(intl.formatMessage({ defaultMessage: 'Text link' }));
  const [isValid, setIsValid] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  function handleChange(isValid, newNumber, countryData, fullNumber) {
    setIsValid(isValid);
    setPhoneNumber(fullNumber);
  }

  function sendTextMessage() {
    setShowSpinner(true);
    sendSMSMessage(phoneNumber, shareObject, languageRegionCode, () => {
      setShowSpinner(false);
      setButtonLabel(intl.formatMessage({ defaultMessage: 'Failed' }));
    });
  }

  const button = (
    <Button text={buttonLabel} type="button" disabled={!isValid} loading={showSpinner} size="md" onClick={sendTextMessage} variant="primary" />
  );

  return (
    <div className={styles.messagingContainer}>
      <p>
        {intl.formatMessage({
          defaultMessage:
            'Text this trail to your friends, family or yourself so you can get driving directions and see detailed trail maps on the go.'
        })}
      </p>
      <div className={styles.form}>
        <Phone onChange={handleChange} classes={styles.phone} />
        <div className={classNames(styles.button, { [styles.disabled]: !isValid, [styles.loading]: showSpinner })}>{button}</div>
      </div>
    </div>
  );
}

ShareModalDrawerTextMessage.propTypes = {
  sendSMSMessage: PropTypes.func.isRequired,
  shareObject: PropTypes.shape({
    type: PropTypes.string.isRequired
  }).isRequired
};

export default ShareModalDrawerTextMessage;
